import { render, staticRenderFns } from "./diagnostic-rule-manager.vue?vue&type=template&id=39e8ffe4&scoped=true&"
import script from "./diagnostic-rule-manager.vue?vue&type=script&lang=js&"
export * from "./diagnostic-rule-manager.vue?vue&type=script&lang=js&"
import style0 from "./diagnostic-rule-manager.vue?vue&type=style&index=0&id=39e8ffe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e8ffe4",
  null
  
)

export default component.exports